import { API, Storage } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

import EquipmentDocumentForm from "components/equipments/documents/EquipmentDocumentForm";
import { createEquipmentDocument } from "graphql/mutations";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const EquipmentDocumentCreateForm = ({ equipmentID, onSuccess }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const equipmentDocument = {
    fileName: "",
    fileSrc: "",
  };

  async function onSubmit(valuesParam) {
    try {
      setLoading(true);

      const { fileName, fileSrc: fileObj } = valuesParam;
      let fileSrc = "";

      if (fileObj) {
        fileSrc = `${fileObj.name
          .split(".")
          .slice(0, -1)
          .join(".")}_${Date.now()}.${fileObj.name.split(".").slice(-1)[0]}`;

        await Storage.put(`equipments/${fileSrc}`, fileObj, {
          contentType: fileObj.type,
          level: "public",
        });
      }

      await API.graphql({
        query: createEquipmentDocument.replaceAll("__typename", ""),
        variables: {
          input: {
            equipmentID,
            fileName,
            fileSrc,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/equipments");
    } catch (err) {
      console.log("Error Equipment Document creation", err);
      toast.error(strings.responses.unexpectedError);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <EquipmentDocumentForm
        onSubmit={onSubmit}
        initialValues={equipmentDocument}
      />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Documento de Equipo",
    successAdded: "Documento de Equipo agregado con éxito",
    responses: {
      unexpectedError: "Error inesperado en la creación",
    },
  },
});

export default EquipmentDocumentCreateForm;
